define([
    "dojo/_base/declare"
], function (declare) {
    return declare([], {
        /**
         * This class defines an interface via which a container temporarily lends out children.  It allows
         * children to be borrowed from their "permanent" location within a SideContainer, BottomContainer
         * or DocumentContainer so that they can temporarily be displayed on-top under control of a BorderBar.
         */
        borrowChild: function (properties) {
        },

        returnChild: function (properties) {
        }
    });
});
